import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

interface Step {
  label: string;
  description: string;
}

interface ProgressStepperProps {
  steps: Step[];
  currentStep: number;
}

export const ProgressStepper: React.FC<ProgressStepperProps> = ({
  steps,
  currentStep,
}) => {
  return (
    <div className="w-full py-4 sm:py-6">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          return (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <motion.div
                  initial={false}
                  animate={{
                    scale: isCurrent ? 1.05 : 1,
                    backgroundColor: isCompleted
                      ? '#10B981'
                      : isCurrent
                      ? '#3B82F6'
                      : '#E5E7EB',
                  }}
                  transition={{ duration: 0.3 }}
                  className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2"
                  style={{
                    borderColor: isCompleted
                      ? '#10B981'
                      : isCurrent
                      ? '#3B82F6'
                      : '#E5E7EB',
                  }}
                >
                  {isCompleted ? (
                    <Check className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                  ) : (
                    <span
                      className={`text-xs sm:text-sm font-semibold ${
                        isCurrent ? 'text-white' : 'text-gray-500'
                      }`}
                    >
                      {index + 1}
                    </span>
                  )}
                </motion.div>

                {/* Step Label */}
                <div className="mt-1.5 text-center">
                  <p
                    className={`text-[10px] sm:text-xs font-medium ${
                      isCurrent
                        ? 'text-avi-primary'
                        : isCompleted
                        ? 'text-avi-accent'
                        : 'text-gray-500'
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="text-[9px] sm:text-[10px] text-gray-400 mt-0.5 hidden sm:block">
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 mx-2 sm:mx-3 mb-8 sm:mb-10">
                  <motion.div
                    initial={false}
                    animate={{
                      backgroundColor: isCompleted ? '#10B981' : '#E5E7EB',
                    }}
                    transition={{ duration: 0.3 }}
                    className="h-0.5 rounded-full"
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
